import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@services/auth/auth.service';
import { MessageAlertService } from '@services/notifications/message-alert.service';
import { AuthFormComponent } from '@shared/components/auth-form/auth-form.component';

@Component({
	selector: 'app-reset-password',
	imports: [AuthFormComponent],
	templateUrl: './reset-password.component.html',
	styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
	isRegister = 2;
	/**
	 * Feeds `app-auth-form`'s [loading]: without it the button never disabled
	 * and a double click sent TWO reset emails. Stays true after success — the
	 * screen is about to redirect and re-enabling would reopen the same hole.
	 */
	loading = false;

	constructor(
		private authService: AuthService,
		private messageAlertService: MessageAlertService,
		private router: Router,
		private translocoService: TranslocoService,
	) {}

	onReset(formData: { email?: string; password?: string; newPassword?: string; confirmPassword?: string }): void {
		if (!formData.email || this.loading) {
			return;
		}

		this.loading = true;
		this.authService.resetPassword(formData.email).subscribe({
			next: () => {
				this.messageAlertService.showMessage(
					'success',
					this.translocoService.translate('auth.resetPassword.messages.emailSent'),
					this.translocoService.translate('auth.resetPassword.messages.emailSentDescription'),
				);
				// Redirect to login after 2 seconds
				setTimeout(() => {
					this.router.navigate(['/login']);
				}, 2000);
			},
			error: () => {
				// Error is already handled by the service
				this.loading = false;
			},
		});
	}
}
